/* eslint-disable no-debugger */
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useSnackbar } from 'notistack5';
import { Form, FormikProvider, useFormik } from 'formik';
// material
import { LoadingButton } from '@material-ui/lab';
import {
  Box,
  Card,
  Grid,
  Stack,
  Checkbox,
  TextField,
  Autocomplete,
  Typography,
  FormControlLabel,
  Chip,
  OutlinedInput,
  InputLabel,
  MenuItem,
  ListItemText,
  Select,
  FormControl
} from '@material-ui/core';
// redux
import CaseConvertor from '../../common-components/CaseConvertor';
import { useDispatch, useSelector } from '../../../redux/store';
import { createVendor, updateVendor, resetCreateVendorStatus, resetVendorError } from '../../../redux/slices/vendor';

// ----------------------------------------------------------------------

CreateVendorForm.propTypes = {
  editId: PropTypes.number,
  setVisibleComponent: PropTypes.func,
  currentVendor: PropTypes.object,
  moduleList: PropTypes.object
};

const VENDOR_TYPE_OPTION = ['Internal', 'External'];
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};
export default function CreateVendorForm({ editId, currentVendor = {}, setVisibleComponent, moduleList }) {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { error, createVendorStatus, isLoading } = useSelector((state) => state.vendor);

  useEffect(() => {
    if (error || createVendorStatus) {
      enqueueSnackbar(
        (createVendorStatus && (!editId ? 'New Vendor Created Successfully' : 'Vendor Updated Successfully')) ||
          (error && error),
        { variant: error ? 'error' : 'success' }
      );
      dispatch(resetVendorError());
    }
    if (createVendorStatus) {
      setVisibleComponent('List');
      formik.resetForm();
      dispatch(resetCreateVendorStatus());
    }
  }, [error, createVendorStatus]);

  const NewVendorSchema = Yup.object().shape({
    vendor_name: Yup.string().required('Vendor name is required'),
    vendor_type: Yup.mixed().required('Vendor Type is required')
    // email: Yup.string().email('Email must be a valid email address').required('Email is required'),
    // password: editId ? '' : Yup.string().required('Password is required')
  });

  const editTempData = {
    editVendorName: currentVendor.vendor_name ? currentVendor.vendor_name : '',
    editVendorType: currentVendor.vendortype ? VENDOR_TYPE_OPTION.filter((a) => a === currentVendor.vendortype) : ''
    // editEmail: currentVendor.email ? currentVendor.email : '',
    // editPassword: currentVendor.password ? currentVendor.password : '',
    // editPermissions: currentVendor.permissions ? currentVendor.permissions : [],
    // editChangePassword: currentVendor.must_change_password ? currentVendor.must_change_password : false
  };
  const handleChange = (event) => {
    const {
      target: { value }
    } = event;
    // setModuleName(
    //   // On autofill we get a stringified value.
    //   typeof value === 'string' ? value.split(',') : value
    // );
    formik.setFieldValue('permissions', typeof value === 'string' ? value.split(',') : value);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      vendor_name: editId ? editTempData.editVendorName : '',
      vendor_type: editId ? editTempData.editVendorType[0] : ''
      // email: editId ? editTempData.editEmail : '',
      // password: editId ? editTempData.editPassword : '',
      // permissions: editId ? editTempData.editPermissions : [],
      // changePassword: editId ? editTempData.editChangePassword : false
    },
    validationSchema: NewVendorSchema,
    onSubmit: async (values, { setSubmitting, setErrors }) => {
      try {
        const vendorData = {
          vendor_name: CaseConvertor(values.vendor_name),
          vendortype: values.vendor_type
          // email: values.email,
          // password: values.password,
          // permissions: JSON.stringify(values.permissions),
          // must_change_password: values.changePassword
        };
        dispatch(!editId ? createVendor(vendorData) : updateVendor(vendorData, editId));
        setSubmitting(false);
      } catch (error) {
        console.error(error);
        setErrors(error);
      }
    }
  });

  const { errors, values, touched, handleSubmit, setFieldValue, getFieldProps } = formik;

  return (
    <FormikProvider value={formik}>
      <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Card sx={{ p: 3 }}>
              <Stack spacing={3}>
                <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
                  <TextField
                    fullWidth
                    label="Vendor"
                    required
                    {...getFieldProps('vendor_name')}
                    error={Boolean(touched.vendor_name && errors.vendor_name)}
                    helperText={touched.vendor_name && errors.vendor_name}
                  />
                </Stack>
                <Autocomplete
                  fullWidth
                  name="Vendor Type"
                  value={values?.vendor_type ? values?.vendor_type : null}
                  options={VENDOR_TYPE_OPTION}
                  onChange={(e, value) => setFieldValue('vendor_type', value)}
                  getOptionLabel={(option) => option}
                  renderInput={(params) => (
                    <TextField
                      error={Boolean(touched.vendor_type && errors.vendor_type)}
                      helperText={touched.vendor_type && errors.vendor_type}
                      required
                      {...params}
                      label="Vendor Type"
                      margin="none"
                    />
                  )}
                />
                {/* <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
                  <TextField
                    fullWidth
                    label="Email"
                    required
                    {...getFieldProps('email')}
                    error={Boolean(touched.email && errors.email)}
                    helperText={touched.email && errors.email}
                  />
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
                  <TextField
                    fullWidth
                    required={!editId}
                    label="Password"
                    {...getFieldProps('password')}
                    error={Boolean(touched.password && errors.password)}
                    helperText={touched.password && errors.password}
                  />
                </Stack> */}
                {/* <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
                  <FormControl>
                    <InputLabel id="Module-wise-permission">Module Wise Permission</InputLabel>
                    <Select
                      labelId="Module-wise-permission"
                      id="Module-wise-permission"
                      multiple
                      value={values?.permissions ? values?.permissions : null}
                      onChange={handleChange}
                      input={<OutlinedInput label="Module Wise Permission" />}
                      renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {selected.map((value) => (
                            <Chip key={value} label={value} />
                          ))}
                        </Box>
                      )}
                      MenuProps={MenuProps}
                    >
                      {moduleList?.map((name) => (
                        <MenuItem sx={{ paddingBottom: '3px', paddingTop: '3px' }} key={name} value={name}>
                          <Checkbox checked={values.permissions.indexOf(name) > -1} />
                          <ListItemText primary={name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack> */}
                {/* <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
                  <FormControlLabel
                    control={<Checkbox {...getFieldProps('changePassword')} checked={values.changePassword} />}
                    label={<Typography variant="button">Must Change Password</Typography>}
                  />
                </Stack> */}
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                  <LoadingButton type="submit" variant="contained" loading={isLoading}>
                    {!editId ? 'Save' : 'Save Changes'}
                  </LoadingButton>
                </Box>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Form>
    </FormikProvider>
  );
}
